import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { endpoints } from 'global/endpoints';
import http from 'utils/http';

const fetchPlans = (plan: string) => {
  const newEndpoints = endpoints.accountBilling.plans.replace('{plan}', plan);
  return http().get(newEndpoints);
};

export function useFetchPlans(plan: string): UseQueryResult<any> {
  return useQuery({ queryKey: ['fetchPlans', plan], queryFn: () => fetchPlans(plan), enabled: !!plan });
}
